// eslint-disable-next-line import/prefer-default-export
export const HOST =
  // eslint-disable-next-line no-underscore-dangle
  window.__ENV__ === 'production'
    ? 'https://www.customink.com'
    : 'https://www-master.staging.customink.com';
